export enum BankAccountType {
    CHECKING_ACCOUNT = 'CHECKING_ACCOUNT',
    SAVINGS_ACCOUNT =  'SAVINGS_ACCOUNT',
}